export const maskApiKey = (key: string): string => {
    if (!key || key.length <= 11) {
        return '••••••••••••';
    }

    const prefix = key.substring(0, 7);
    const suffix = key.substring(key.length - 4);
    const maskedLength = Math.max(12, key.length - 11);

    return `${prefix}${'•'.repeat(maskedLength)}${suffix}`;
};
